// ==============================================================================
// Story 004: The Nightmare Shop
// Level: 2 (Middle School Year 2-3)
// Target: ~6 sentences per page, High Density, Total 8 Pages
// ==============================================================================

const STORY_DATA = [
  {
    title: "Page 1: The Missed Goal",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "standing", r: "スタンディング", s: true },
      { w: "on", r: "オン" },
      { w: "the", r: "ザ" },
      { w: "soccer", r: "サッカー" },
      { w: "field.", r: "フィールド" , s: true},
      { w: "Everyone", r: "エブリワン" },
      { w: "is", r: "イズ" },
      { w: "watching", r: "ウォッチング", s: true },
      { w: "me.", r: "ミー" , s: true},
      { w: "I", r: "アイ" },
      { w: "kick", r: "キック" },
      { w: "the", r: "ザ" },
      { w: "ball,", r: "ボール", s: true },
      { w: "but", r: "バット" },
      { w: "I", r: "アイ" },
      { w: "miss", r: "ミス" },
      { w: "the", r: "ザ" },
      { w: "goal.", r: "ゴール" , s: true},
      { w: "The", r: "ザ" },
      { w: "crowd", r: "クラウド" },
      { w: "laughs", r: "ラフス", s: true },
      { w: "loudly.", r: "ラウドリー" , s: true},
      { w: "'You", r: "ユー" },
      { w: "cannot", r: "キャノット" },
      { w: "do", r: "ドゥ" },
      { w: "it!'", r: "イット" , s: true},
      { w: "a", r: "ア" },
      { w: "dark", r: "ダーク" },
      { w: "shadow", r: "シャドウ", s: true },
      { w: "says.", r: "セイズ" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "very", r: "ベリー" },
      { w: "scared.", r: "スケアード" , s: true},
    ],
    en: "I am standing on the soccer field. Everyone is watching me. I kick the ball, but I miss the goal. The crowd laughs loudly. 'You cannot do it!' a dark shadow says. I am very scared.",
    ja: "僕はサッカー場に立っています。みんなが僕を見ています。ボールを蹴りますが、ゴールを外してしまいます。観衆が大声で笑います。「お前には無理だ！」と黒い影が言います。僕はとても怖いです。",
    learning: {
      vocab: [
        { word: "crowd", mean: "群衆・観衆" },
        { word: "shadow", mean: "影" },
        { word: "scared", mean: "怖がっている" },
      ],
      grammar: {
        title: "現在進行形",
        desc: "be動詞 + ~ing で「今～している」という進行中の動作を表します。",
        key: "Everyone is watching me.",
      },
    },
    color: "bg-slate-900",
    accent: "text-slate-300",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/004/01.jpg",
    startTime: 0,
  },
  {
    title: "Page 2: Sleepless Nights",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "wake", r: "ウェイク" },
      { w: "up", r: "アップ", s: true },
      { w: "in", r: "イン" },
      { w: "my", r: "マイ" },
      { w: "bed.", r: "ベッド" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "sweating.", r: "スウェッティング", s: true },
      { w: "It", r: "イット" },
      { w: "was", r: "ワズ" },
      { w: "just", r: "ジャスト" },
      { w: "a", r: "ア" },
      { w: "bad", r: "バッド" },
      { w: "dream,", r: "ドリーム", s: true },
      { w: "but", r: "バット" },
      { w: "my", r: "マイ" },
      { w: "heart", r: "ハート" },
      { w: "is", r: "イズ" },
      { w: "beating", r: "ビーティング" },
      { w: "fast.", r: "ファスト" , s: true},
      { w: "I", r: "アイ" },
      { w: "cannot", r: "キャノット" },
      { w: "sleep", r: "スリープ", s: true },
      { w: "well", r: "ウェル" },
      { w: "these", r: "ディーズ" },
      { w: "days.", r: "デイズ" , s: true},
      { w: "The", r: "ザ" },
      { w: "big", r: "ビッグ" },
      { w: "game", r: "ゲーム" },
      { w: "is", r: "イズ" },
      { w: "coming", r: "カミング", s: true },
      { w: "soon.", r: "スーン" , s: true},
      { w: "I", r: "アイ" },
      { w: "do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "want", r: "ウォント" },
      { w: "to", r: "トゥ" },
      { w: "fail.", r: "フェイル", s: true },
    ],
    en: "I wake up in my bed. I am sweating. It was just a bad dream, but my heart is beating fast. I cannot sleep well these days. The big game is coming soon. I do not want to fail.",
    ja: "ベッドで目を覚まします。汗をかいています。ただの悪夢でしたが、心臓が速く脈打っています。この頃よく眠れません。大きな試合がもうすぐあります。僕は失敗したくありません。",
    learning: {
      vocab: [
        { word: "sweat", mean: "汗をかく" },
        { word: "beat", mean: "（心臓が）鼓動する" },
        { word: "fail", mean: "失敗する" },
      ],
      grammar: {
        title: "want to + 動詞",
        desc: "「～したい」という願望を表します。否定形は do not want to です。",
        key: "I do not want to fail.",
      },
    },
    color: "bg-indigo-100",
    accent: "text-indigo-800",
    mood: { rate: 1.0, pitch: 0.9 },
    image: "images/004/02.jpg",
    startTime: 20,
  },
  {
    title: "Page 3: The Mysterious Van",
    rubyText: [
      { w: "After", r: "アフター" },
      { w: "school,", r: "スクール", s: true },
      { w: "I", r: "アイ" },
      { w: "walk", r: "ウォーク" },
      { w: "home", r: "ホーム", s: true },
      { w: "slowly.", r: "スローリー", s: true },
      { w: "I", r: "アイ" },
      { w: "see", r: "シー" },
      { w: "a", r: "ア" },
      { w: "strange", r: "ストレンジ" },
      { w: "van", r: "バン", s: true },
      { w: "in", r: "イン" },
      { w: "a", r: "ア" },
      { w: "dark", r: "ダーク" },
      { w: "street.", r: "ストリート" , s: true},
      { w: "A", r: "ア" },
      { w: "man", r: "マン" },
      { w: "is", r: "イズ" },
      { w: "reading", r: "リーディング", s: true },
      { w: "a", r: "ア" },
      { w: "book", r: "ブック" },
      { w: "there.", r: "ゼア" , s: true},
      { w: "He", r: "ヒー" },
      { w: "is", r: "イズ" },
      { w: "wearing", r: "ウェアリング" },
      { w: "a", r: "ア" },
      { w: "hat", r: "ハット", s: true },
      { w: "and", r: "アンド" },
      { w: "glasses.", r: "グラシーズ" , s: true},
      { w: "He", r: "ヒー" },
      { w: "looks", r: "ルックス" },
      { w: "at", r: "アット" },
      { w: "me", r: "ミー", s: true },
      { w: "and", r: "アンド" },
      { w: "smiles.", r: "スマイルズ" , s: true},
    ],
    en: "After school, I walk home slowly. I see a strange van in a dark street. A man is reading a book there. He is wearing a hat and glasses. He looks at me and smiles.",
    ja: "放課後、ゆっくりと家に帰ります。暗い通りで奇妙なバン（車）を見つけます。一人の男がそこで本を読んでいます。彼は帽子をかぶり、眼鏡をかけています。彼は私を見て微笑みます。",
    learning: {
      vocab: [
        { word: "strange", mean: "奇妙な" },
        { word: "wear", mean: "着ている、身につけている" },
        { word: "glasses", mean: "眼鏡" },
      ],
      grammar: {
        title: "Look at",
        desc: "「～を見る」と言うときは、lookの後ろにatが必要です。",
        key: "He looks at me.",
      },
    },
    color: "bg-purple-100",
    accent: "text-purple-700",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/004/03.jpg",
    startTime: 40,
  },
  {
    title: "Page 4: Selling Nightmares",
    rubyText: [
      { w: "'Hello,", r: "ハロー" },
      { w: "young", r: "ヤング" },
      { w: "boy,'", r: "ボーイ", s: true },
      { w: "the", r: "ザ" },
      { w: "man", r: "マン" },
      { w: "says.", r: "セイズ" , s: true},
      { w: "'I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "Baku.", r: "バク" , s: true},
      { w: "I", r: "アイ" },
      { w: "buy", r: "バイ" },
      { w: "nightmares.'", r: "ナイトメアーズ", s: true },
      { w: "'You", r: "ユー" },
      { w: "buy", r: "バイ" },
      { w: "bad", r: "バッド" },
      { w: "dreams?'", r: "ドリームス", s: true },
      { w: "I", r: "アイ" },
      { w: "ask.", r: "アスク" , s: true},
      { w: "'Yes.", r: "イエス" },
      { w: "But", r: "バット" },
      { w: "I", r: "アイ" },
      { w: "do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "need", r: "ニード", s: true },
      { w: "money.", r: "マネー" , s: true},
      { w: "I", r: "アイ" },
      { w: "want", r: "ウォント" },
      { w: "your", r: "ユア" },
      { w: "happy", r: "ハッピー" },
      { w: "memories", r: "メモリーズ", s: true },
      { w: "instead.'", r: "インステッド" , s: true},
      { w: "I", r: "アイ" },
      { w: "decide", r: "ディサイド" },
      { w: "to", r: "トゥ" },
      { w: "sell", r: "セル", s: true },
      { w: "my", r: "マイ" },
      { w: "fear.", r: "フィアー" , s: true},
    ],
    en: "'Hello, young boy,' the man says. 'I am Baku. I buy nightmares.' 'You buy bad dreams?' I ask. 'Yes. But I do not need money. I want your happy memories instead.' I decide to sell my fear.",
    ja: "「こんにちは、少年」男は言います。「私はバク。悪夢を買います」「悪い夢を買うの？」僕は聞きます。「ええ。でもお金はいりません。代わりにあなたの楽しい思い出が欲しいのです」僕は恐怖を売ることに決めました。",
    learning: {
      vocab: [
        { word: "nightmare", mean: "悪夢" },
        { word: "instead", mean: "その代わりに" },
        { word: "decide", mean: "決める" },
      ],
      grammar: {
        title: "decide to ...",
        desc: "「～することを決める」という表現です。",
        key: "I decide to sell my fear.",
      },
    },
    color: "bg-fuchsia-100",
    accent: "text-fuchsia-800",
    mood: { rate: 1.0, pitch: 0.9 },
    image: "images/004/04.jpg",
    startTime: 60,
  },
  {
    title: "Page 5: Perfect but Cold",
    rubyText: [
      { w: "The", r: "ザ" },
      { w: "next", r: "ネクスト" },
      { w: "day,", r: "デイ", s: true },
      { w: "I", r: "アイ" },
      { w: "feel", r: "フィール" },
      { w: "great.", r: "グレート" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "perfect", r: "パーフェクト", s: true },
      { w: "at", r: "アット" },
      { w: "soccer.", r: "サッカー" , s: true},
      { w: "I", r: "アイ" },
      { w: "never", r: "ネバー" },
      { w: "make", r: "メイク" },
      { w: "mistakes.", r: "ミステイクス" , s: true},
      { w: "Also,", r: "オルソー", s: true },
      { w: "I", r: "アイ" },
      { w: "get", r: "ゲット" },
      { w: "100", r: "ワンハンドレッド" },
      { w: "points", r: "ポインツ", s: true },
      { w: "on", r: "オン" },
      { w: "tests.", r: "テスツ" , s: true},
      { w: "My", r: "マイ" },
      { w: "heart", r: "ハート" },
      { w: "is", r: "イズ" },
      { w: "very", r: "ベリー" },
      { w: "quiet.", r: "クワイエット" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "like", r: "ライク" },
      { w: "a", r: "ア" },
      { w: "robot", r: "ロボット", s: true },
      { w: "now.", r: "ナウ" , s: true},
    ],
    en: "The next day, I feel great. I am perfect at soccer. I never make mistakes. Also, I get 100 points on tests. My heart is very quiet. I am like a robot now.",
    ja: "翌日、気分は最高です。サッカーは完璧です。ミスをしません。テストでも100点を取ります。僕の心はとても静かです。僕は今、ロボットのようです。",
    learning: {
      vocab: [
        { word: "perfect", mean: "完璧な" },
        { word: "mistake", mean: "間違い" },
        { word: "quiet", mean: "静かな" },
      ],
      grammar: {
        title: "like a ...",
        desc: "ここでの like は「～が好き」ではなく「～のような」という意味の前置詞です。",
        key: "I am like a robot.",
      },
    },
    color: "bg-cyan-50",
    accent: "text-cyan-600",
    mood: { rate: 1.1, pitch: 1.0 },
    image: "images/004/05.jpg",
    startTime: 80,
  },
  {
    title: "Page 6: No Feelings",
    rubyText: [
      { w: "My", r: "マイ" },
      { w: "friend", r: "フレンド" },
      { w: "Minami", r: "ミナミ" },
      { w: "talks", r: "トークス", s: true },
      { w: "to", r: "トゥ" },
      { w: "me.", r: "ミー" , s: true},
      { w: "'Kakeru,", r: "カケル", s: true },
      { w: "let's", r: "レッツ" },
      { w: "eat", r: "イート" },
      { w: "pork", r: "ポーク" },
      { w: "buns!'", r: "バンズ" , s: true},
      { w: "I", r: "アイ" },
      { w: "look", r: "ルック" },
      { w: "at", r: "アット" },
      { w: "her", r: "ハー", s: true },
      { w: "coldly.", r: "コールドリー" , s: true},
      { w: "'No.", r: "ノー" },
      { w: "Eating", r: "イーティング" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "waste", r: "ウェイスト", s: true },
      { w: "of", r: "オブ" },
      { w: "time.'", r: "タイム" , s: true},
      { w: "Minami", r: "ミナミ" },
      { w: "looks", r: "ルックス" },
      { w: "sad,", r: "サッド", s: true },
      { w: "but", r: "バット" },
      { w: "I", r: "アイ" },
      { w: "do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "care.", r: "ケア" , s: true},
      { w: "I", r: "アイ" },
      { w: "have", r: "ハブ" },
      { w: "lost", r: "ロスト" },
      { w: "my", r: "マイ" },
      { w: "feelings.", r: "フィーリングス" , s: true},
    ],
    en: "My friend Minami talks to me. 'Kakeru, let's eat pork buns!' I look at her coldly. 'No. Eating is a waste of time.' Minami looks sad, but I do not care. I have lost my feelings.",
    ja: "友達のミナミが話しかけてきます。「カケル、肉まん食べようよ！」僕は彼女を冷たく見ます。「いいや。食べることは時間の無駄だ」ミナミは悲しそうですが、僕は気にしません。僕は感情を失ってしまいました。",
    learning: {
      vocab: [
        { word: "pork bun", mean: "肉まん" },
        { word: "waste", mean: "無駄" },
        { word: "feeling", mean: "感情" },
      ],
      grammar: {
        title: "動名詞",
        desc: "Eating のように動詞にingをつけると「～すること」という名詞になります。",
        key: "Eating is a waste of time.",
      },
    },
    color: "bg-gray-200",
    accent: "text-gray-500",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/004/06.jpg",
    startTime: 100,
  },
  {
    title: "Page 7: The Last Deal",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "go", r: "ゴー" },
      { w: "to", r: "トゥ" },
      { w: "the", r: "ザ" },
      { w: "shop", r: "ショップ", s: true },
      { w: "again.", r: "アゲイン" , s: true},
      { w: "'Please", r: "プリーズ" },
      { w: "remove", r: "リムーブ" },
      { w: "my", r: "マイ" },
      { w: "last", r: "ラスト" },
      { w: "fear,'", r: "フィアー", s: true },
      { w: "I", r: "アイ" },
      { w: "say.", r: "セイ" , s: true},
      { w: "Baku", r: "バク" },
      { w: "shows", r: "ショウズ" },
      { w: "me", r: "ミー" },
      { w: "a", r: "ア" },
      { w: "bottle.", r: "ボトル" , s: true},
      { w: "'The", r: "ザ" },
      { w: "price", r: "プライス" },
      { w: "is", r: "イズ" },
      { w: "your", r: "ユア" },
      { w: "love", r: "ラブ", s: true },
      { w: "for", r: "フォー" },
      { w: "soccer.'", r: "サッカー" , s: true},
      { w: "I", r: "アイ" },
      { w: "see", r: "シー" },
      { w: "my", r: "マイ" },
      { w: "memory", r: "メモリー", s: true },
      { w: "in", r: "イン" },
      { w: "the", r: "ザ" },
      { w: "bottle.", r: "ボトル" , s: true},
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "laughing", r: "ラフィング", s: true },
      { w: "with", r: "ウィズ" },
      { w: "Minami.", r: "ミナミ" , s: true},
    ],
    en: "I go to the shop again. 'Please remove my last fear,' I say. Baku shows me a bottle. 'The price is your love for soccer.' I see my memory in the bottle. I am laughing with Minami.",
    ja: "僕はまた店に行きます。「最後の恐怖を取り除いてください」と言います。バクは瓶を見せます。「代金は、あなたのサッカーへの愛です」瓶の中に僕の記憶が見えます。僕はミナミと一緒に笑っています。",
    learning: {
      vocab: [
        { word: "remove", mean: "取り除く" },
        { word: "price", mean: "代償・価格" },
        { word: "memory", mean: "記憶" },
      ],
      grammar: {
        title: "進行形 (過去の描写)",
        desc: "記憶の中の光景を描写するために進行形を使っています。",
        key: "I am laughing with Minami.",
      },
    },
    color: "bg-yellow-100",
    accent: "text-yellow-700",
    mood: { rate: 1.0, pitch: 0.9 },
    image: "images/004/07.jpg",
    startTime: 120,
  },
  {
    title: "Page 8: I Keep My Fear",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "stop.", r: "ストップ" , s: true},
      { w: "'No!'", r: "ノー", s: true },
      { w: "I", r: "アイ" },
      { w: "shout.", r: "シャウト" , s: true},
      { w: "'I", r: "アイ" },
      { w: "need", r: "ニード" },
      { w: "this", r: "ディス" },
      { w: "fear.", r: "フィアー" , s: true},
      { w: "Because", r: "ビコーズ", s: true },
      { w: "I", r: "アイ" },
      { w: "love", r: "ラブ" },
      { w: "soccer!'", r: "サッカー" , s: true},
      { w: "I", r: "アイ" },
      { w: "run", r: "ラン" },
      { w: "away.", r: "アウェイ" , s: true},
      { w: "The", r: "ザ" },
      { w: "next", r: "ネクスト" },
      { w: "morning,", r: "モーニング", s: true },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "scared,", r: "スケアード", s: true },
      { w: "but", r: "バット" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "happy.", r: "ハッピー" , s: true},
      { w: "I", r: "アイ" },
      { w: "run", r: "ラン", s: true },
      { w: "to", r: "トゥ" },
      { w: "the", r: "ザ" },
      { w: "field", r: "フィールド" },
      { w: "with", r: "ウィズ" },
      { w: "Minami.", r: "ミナミ" , s: true},
    ],
    en: "I stop. 'No!' I shout. 'I need this fear. Because I love soccer!' I run away. The next morning, I am scared, but I am happy. I run to the field with Minami.",
    ja: "僕は止めます。「だめだ！」と叫びます。「僕はこの恐怖が必要だ。だってサッカーが大好きだから！」僕は走り去ります。翌朝、僕は怖いですが、幸せです。ミナミと一緒にグラウンドへ走ります。",
    learning: {
      vocab: [
        { word: "shout", mean: "叫ぶ" },
        { word: "run away", mean: "逃げ出す" },
        { word: "field", mean: "グラウンド" },
      ],
      grammar: {
        title: "Because",
        desc: "理由を説明する接続詞です。「なぜなら～だから」という意味です。",
        key: "Because I love soccer!",
      },
    },
    color: "bg-sky-200",
    accent: "text-sky-600",
    mood: { rate: 1.1, pitch: 1.0 },
    image: "images/004/08.jpg",
    startTime: 140,
  },
];

const QUIZ_POOL = [
  {
    q: "What happens to Kakeru on Page 1?",
    options: ["He scores a goal", "He misses the goal", "He wins the game"],
    a: 1,
    exp: "Page 1で「I miss the goal」と言っています。",
  },
  {
    q: "Who laughs at Kakeru in his dream?",
    options: ["Minami", "Mr. Roboto", "The crowd and a dark shadow"],
    a: 2,
    exp: "Page 1で「The crowd laughs」と「a dark shadow says」とあります。",
  },
  {
    q: "How does Kakeru feel when he wakes up?",
    options: ["Happy", "Hungry", "Scared and tired"],
    a: 2,
    exp: "Page 2で「my heart is beating fast」「I cannot sleep well」とあります。",
  },
  {
    q: "What is coming soon on Page 2?",
    options: ["A math test", "A big game", "Summer vacation"],
    a: 1,
    exp: "Page 2で「The big game is coming soon」とあります。",
  },
  {
    q: "Where does Kakeru see the strange van?",
    options: ["In a dark street", "At school", "In the park"],
    a: 0,
    exp: "Page 3で「in a dark street」とあります。",
  },
  {
    q: "Who is the man in the van?",
    options: ["A doctor", "Baku", "A soccer coach"],
    a: 1,
    exp: "Page 4で「I am Baku」と名乗っています。",
  },
  {
    q: "What does Baku buy?",
    options: ["Old books", "Delicious food", "Nightmares"],
    a: 2,
    exp: "Page 4で「I buy nightmares」と言っています。",
  },
  {
    q: "What does Baku want instead of money?",
    options: ["Happy memories", "Soccer balls", "Kakeru's shoes"],
    a: 0,
    exp: "Page 4で「I want your happy memories instead」と言っています。",
  },
  {
    q: "How does Kakeru change on Page 5?",
    options: [
      "He becomes bad at soccer",
      "He becomes perfect like a robot",
      "He becomes very angry",
    ],
    a: 1,
    exp: "Page 5で「I am perfect... I am like a robot」とあります。",
  },
  {
    q: "What score does Kakeru get on tests?",
    options: ["0 points", "50 points", "100 points"],
    a: 2,
    exp: "Page 5で「I get 100 points」とあります。",
  },
  {
    q: "What does Minami want to eat?",
    options: ["Sushi", "Pork buns", "Ice cream"],
    a: 1,
    exp: "Page 6で「let's eat pork buns!」と誘っています。",
  },
  {
    q: "How does Kakeru answer Minami?",
    options: ["Coldly", "Happily", "Sadly"],
    a: 0,
    exp: "Page 6で「I look at her coldly」とあります。",
  },
  {
    q: "What does Kakeru think about eating?",
    options: ["It is fun", "It is yummy", "It is a waste of time"],
    a: 2,
    exp: "Page 6で「Eating is a waste of time」と言っています。",
  },
  {
    q: "What is the price for the last fear?",
    options: ["His love for soccer", "His money", "His school bag"],
    a: 0,
    exp: "Page 7で「The price is your love for soccer」とあります。",
  },
  {
    q: "What does Kakeru see in the bottle?",
    options: ["A scary monster", "Himself laughing with Minami", "Nothing"],
    a: 1,
    exp: "Page 7で「I am laughing with Minami」とあります。",
  },
  {
    q: "Why does Kakeru stop the deal?",
    options: [
      "Because he has no money",
      "Because he loves soccer",
      "Because he is sleepy",
    ],
    a: 1,
    exp: "Page 8で「Because I love soccer!」と理由を言っています。",
  },
  {
    q: "What does Kakeru do at the end?",
    options: [
      "He runs away from the shop",
      "He fights Baku",
      "He goes back to sleep",
    ],
    a: 0,
    exp: "Page 8で「I run away」とあります。",
  },
  {
    q: "How does Kakeru feel the next morning?",
    options: ["Scared but happy", "Sad and lonely", "Perfect and cold"],
    a: 0,
    exp: "Page 8で「I am scared, but I am happy」とあります。",
  },
  {
    q: "Who does Kakeru run with at the end?",
    options: ["Alone", "With Baku", "With Minami"],
    a: 2,
    exp: "Page 8で「with Minami」とあります。",
  },
  {
    q: "What is the message of the story?",
    options: [
      "Nightmares are bad",
      "Fear and love are both important",
      "Robots are better than humans",
    ],
    a: 1,
    exp: "恐怖（悪夢）を捨てると愛も失うことに気づく物語です。",
  },
];

const SCRAMBLE_POOL = [
  {
    q: "私はサッカー場に立っています。",
    w: ["I", "am", "standing", "on", "the", "soccer", "field"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "みんなが私を見ています。",
    w: ["Everyone", "is", "watching", "me"],
    o: [0, 1, 2, 3],
  },
  {
    q: "大きな試合がもうすぐあります。",
    w: ["The", "big", "game", "is", "coming", "soon"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "私は失敗したくありません。",
    w: ["I", "do", "not", "want", "to", "fail"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "暗い通りに奇妙なバンが見えます。",
    w: ["I", "see", "a", "strange", "van", "in", "a", "dark", "street"],
    o: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    q: "男は帽子をかぶっています。",
    w: ["The", "man", "is", "wearing", "a", "hat"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "私は悪夢を買います。",
    w: ["I", "buy", "nightmares"],
    o: [0, 1, 2],
  },
  {
    q: "私はお金を必要としません。",
    w: ["I", "do", "not", "need", "money"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "代わりにあなたの楽しい思い出が欲しいです。",
    w: ["I", "want", "your", "happy", "memories", "instead"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "私は恐怖を売ることに決めます。",
    w: ["I", "decide", "to", "sell", "my", "fear"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "私は決して間違いをしません。",
    w: ["I", "never", "make", "mistakes"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私は今、ロボットのようです。",
    w: ["I", "am", "like", "a", "robot", "now"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "肉まんを食べましょう。",
    w: ["Let's", "eat", "pork", "buns"],
    o: [0, 1, 2, 3],
  },
  {
    q: "食べることは時間の無駄です。",
    w: ["Eating", "is", "a", "waste", "of", "time"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "私は彼女を冷たく見ます。",
    w: ["I", "look", "at", "her", "coldly"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "最後の恐怖を取り除いてください。",
    w: ["Please", "remove", "my", "last", "fear"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "代償はあなたのサッカーへの愛です。",
    w: ["The", "price", "is", "your", "love", "for", "soccer"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "なぜなら私はサッカーが好きだからです。",
    w: ["Because", "I", "love", "soccer"],
    o: [0, 1, 2, 3],
  },
  {
    q: "私はミナミと一緒に笑っています。",
    w: ["I", "am", "laughing", "with", "Minami"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "私はミナミと一緒にグラウンドへ走ります。",
    w: ["I", "run", "to", "the", "field", "with", "Minami"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
];

const FILL_IN_THE_BLANK_POOL = [
  {
    q: "Everyone is _______ me.",
    options: ["watching", "watch", "watches", "watched"],
    a: 0,
    exp: "現在進行形なので be動詞 + watching になります。",
  },
  {
    q: "I _______ the goal.",
    options: ["miss", "misses", "missing", "missed"],
    a: 0,
    exp: "現在の話をしているので原形（主語I）の miss を使います。",
  },
  {
    q: "My heart is _______ fast.",
    options: ["beating", "beat", "beats", "beaten"],
    a: 0,
    exp: "進行形 be + -ing で「鼓動している」状態を表します。",
  },
  {
    q: "I cannot _______ well.",
    options: ["sleep", "sleeping", "sleeps", "to sleep"],
    a: 0,
    exp: "助動詞 can/cannot の後は動詞の原形です。",
  },
  {
    q: "I do not want _______ fail.",
    options: ["to", "for", "at", "in"],
    a: 0,
    exp: "want to fail（失敗したい）の否定形です。",
  },
  {
    q: "He _______ at me and smiles.",
    options: ["looks", "look", "looking", "looked"],
    a: 0,
    exp: "主語 He は三人称単数なので looks になります。",
  },
  {
    q: "I want your happy memories _______.",
    options: ["instead", "also", "too", "either"],
    a: 0,
    exp: "「（お金の）代わりに」という意味の instead が文末に入ります。",
  },
  {
    q: "I decide _______ sell my fear.",
    options: ["to", "for", "of", "by"],
    a: 0,
    exp: "decide to ... で「～することを決める」です。",
  },
  {
    q: "I am perfect _______ soccer.",
    options: ["at", "in", "on", "with"],
    a: 0,
    exp: "be good at / be perfect at のように at を使います。",
  },
  {
    q: "I never _______ mistakes.",
    options: ["make", "do", "have", "take"],
    a: 0,
    exp: "「間違いをする」は make mistakes というコロケーションです。",
  },
  {
    q: "I am _______ a robot now.",
    options: ["like", "as", "same", "love"],
    a: 0,
    exp: "「～のような」という意味の前置詞 like です。",
  },
  {
    q: "_______ eat pork buns!",
    options: ["Let's", "Let", "Lets", "Will"],
    a: 0,
    exp: "勧誘の Let's です。",
  },
  {
    q: "Eating is a _______ of time.",
    options: ["waste", "lose", "bad", "lost"],
    a: 0,
    exp: "waste of time（時間の無駄）という決まり文句です。",
  },
  {
    q: "Minami looks _______.",
    options: ["sad", "sadly", "sadness", "sads"],
    a: 0,
    exp: "look + 形容詞 で「～に見える」です。",
  },
  {
    q: "Please _______ my last fear.",
    options: ["remove", "move", "removes", "moving"],
    a: 0,
    exp: "命令文なので動詞の原形で始めます。",
  },
  {
    q: "The price is your love _______ soccer.",
    options: ["for", "to", "at", "in"],
    a: 0,
    exp: "love for ... で「～への愛」を表します。",
  },
  {
    q: "I _______ laughing with Minami.",
    options: ["am", "is", "are", "be"],
    a: 0,
    exp: "主語 I に対するbe動詞は am です。",
  },
  {
    q: "_______ I love soccer!",
    options: ["Because", "So", "But", "And"],
    a: 0,
    exp: "理由を述べるので Because を使います。",
  },
  {
    q: "I run _______.",
    options: ["away", "way", "far", "out"],
    a: 0,
    exp: "run away で「逃げ出す、走り去る」です。",
  },
  {
    q: "I am scared, _______ I am happy.",
    options: ["but", "so", "because", "or"],
    a: 0,
    exp: "逆説（怖い、でも幸せ）なので but を使います。",
  },
];

export default {
  id: "sZ2JHEcS",
  title: "The Nightmare Shop",
  level: "LEVEL 3",
  category: "Fantasy",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};

